import { LoadingButton, LoadingButtonOwnProps } from "@mui/lab";
import { ButtonOwnProps, lighten, styled } from "@mui/material";

type MUIButtonProps = ButtonOwnProps & LoadingButtonOwnProps;

export interface TSSButtonProps extends MUIButtonProps {
  children: React.ReactNode;
  colorScheme?: string; // hex color
  // rest props
  [k: string]: any;
}

export const SSButton = styled(({ colorScheme, ...props }: TSSButtonProps) => (
  <LoadingButton
    disableElevation
    variant={props.variant || "contained"}
    {...props}
  />
))(({ colorScheme, theme, variant, disabled, loading }) => {
  if (!colorScheme) colorScheme = theme.palette.primary.main;
  const sx: any = {};
  if (colorScheme) {
    if (variant === "contained") {
      sx.backgroundColor = colorScheme;
      sx.color = theme.palette.getContrastText(colorScheme);
      sx.borderColor = colorScheme;
      sx["&:hover"] = {
        backgroundColor: lighten(colorScheme, 0.2),
        borderColor: lighten(colorScheme, 0.2),
      };
    }

    if (variant === "outlined") {
      sx.borderColor = colorScheme;
      sx.color = colorScheme;
      sx["&:hover"] = {
        backgroundColor: lighten(colorScheme, 0.8),
        color: theme.palette.getContrastText(lighten(colorScheme, 0.8)),
        borderColor: colorScheme,
      };
    }

    if (loading) {
      sx.backgroundColor = `${colorScheme} !important`;
      sx.opacity = 0.5;
      sx["& .MuiLoadingButton-loadingIndicator"] = {
        color: theme.palette.getContrastText(colorScheme),
      };
    }

    if (disabled && !loading) {
      sx.backgroundColor = `${colorScheme} !important`;
      sx.color = `${theme.palette.getContrastText(colorScheme)} !important`;
      sx.opacity = 0.5;
    }
  }

  sx.borderRadius = "48px";
  sx.textTransform = "none";
  return sx;
});
